module.exports = __webpack_public_path__ + "static/image/company/m/culture-2.ver2_0_2.jpg?07631fb9";